import type { ReactNode } from 'react';

/** antd Select maxTagPlaceholder 入参 */
export type IpcSelectOmittedValue = {
  label?: ReactNode;
  value?: string | number;
};

/** 筛选条多选溢出文案：与 antd 官方示例一致，如「+ 2 ...」 */
export function ipcFilterMaxTagPlaceholder(omittedValues: IpcSelectOmittedValue[]): string {
  return `+ ${omittedValues.length} ...`;
}

/** 筛选条 Select 下拉挂载到 body，避免被表格区域 overflow 裁剪 */
export const IPC_FILTER_SELECT_POPUP_PROPS = {
  getPopupContainer: () => document.body,
} as const;

/**
 * 筛选条多选 Select 通用 props
 * - 使用 antd 原生 tag 展示已选项 label
 * - 宽度不足时 responsive 折叠，溢出显示「+ N ...」
 */
export const IPC_FILTER_MULTI_SELECT_PROPS = {
  ...IPC_FILTER_SELECT_POPUP_PROPS,
  maxTagCount: 'responsive' as const,
  maxTagPlaceholder: ipcFilterMaxTagPlaceholder,
};
